<div class="flex row error-600-text pad-vertical-10">
  <span class="icon-alert margin-right-5 margin-top-5"></span>
  <p>{{ messageText }}</p>
</div>
